import {
  Box,
  Button,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import backgroundImage from '../assets/Images/cse-building.webp';

const HeroSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLearnMoreClick = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSubmitPaperClick = () => {
    // Open external link to submission portal
    window.open('https://openreview.net/group?id=ADScAI/2026/Conference', '_blank');
  };

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '90vh',
        overflow: 'hidden',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
        px: 2,
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.6)',
        }}
      />

      {/* Content */}
      <Container
        maxWidth='md'
        sx={{
          position: 'relative',
          zIndex: 1,
          py: 4,
        }}
      >
        <Typography variant={isSmallScreen ? 'h4' : 'h2'} fontWeight='bold'>
          ADScAI Conference
          <span style={{ color: '#7cd400' }}> 2026</span>
        </Typography>
        <Typography
          variant={isSmallScreen ? 'body1' : 'h6'}
          mt={2}
          sx={{ maxWidth: '800px', mx: 'auto' }}
        >
          The second conference bringing together pioneers in Data Science and AI <br/>
          Organized by the Department of Computer Science & Engineering, <br/>
          Faculty of Engineering,
          University of Moratuwa.
        </Typography>
        <Typography
          variant={isSmallScreen ? 'body2' : 'subtitle1'}
          mt={3}
          fontWeight='bold'
        >
          29th April 2026 | University of Moratuwa, Sri Lanka
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          {/*<Button*/}
          {/*  variant='contained'*/}
          {/*  href={'https://forms.gle/WFzDNBjC6uM153HMA'}*/}
          {/*  sx={{*/}
          {/*    bgcolor: '#f5ffe6',*/}
          {/*    color: 'black',*/}
          {/*    fontWeight: 'bold',*/}
          {/*    px: isSmallScreen ? 2 : 4,*/}
          {/*    py: isSmallScreen ? 1 : 1.5,*/}
          {/*    fontSize: isSmallScreen ? '0.875rem' : '1rem',*/}
          {/*  }}*/}
          {/*>*/}
          {/*  Register Now*/}
          {/*</Button>*/}
          {/*<Button*/}
          {/*  variant='contained'*/}
          {/*  sx={{*/}
          {/*    bgcolor: '#7cd400',*/}
          {/*    color: 'black',*/}
          {/*    fontWeight: 'bold',*/}
          {/*    px: isSmallScreen ? 2 : 4,*/}
          {/*    py: isSmallScreen ? 1 : 1.5,*/}
          {/*    fontSize: isSmallScreen ? '0.875rem' : '1rem',*/}
          {/*  }}*/}
          {/*  onClick={handleSubmitPaperClick}*/}
          {/*>*/}
          {/*  Submit Paper*/}
          {/*</Button>*/}
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
